import BlogsMain from "../components/BlogsMain";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Discovery(){
    return(
        <>
            <Header/>
            <BlogsMain></BlogsMain>
            <Footer></Footer>
        </>
    );
}

export default Discovery;